/**
 * Web-only hover elevation for maintenance cards: a box-shadow plus an optional
 * lift transform. Returns null when not hovered or off-web, so native renders
 * exactly as before. The lift is suppressed under reduced-motion (the shadow,
 * which is color not motion, still applies).
 */
export function buildCardHoverStyle(params: {
  isHovered: boolean;
  reduceMotion: boolean;
  isWeb: boolean;
  shadowHover: string;
  liftPx: number;
}): any[] | null {
  const { isHovered, reduceMotion, isWeb, shadowHover, liftPx } = params;
  if (!isHovered || !isWeb) return null;
  const out: any[] = [{ boxShadow: shadowHover }];
  if (!reduceMotion) out.push({ transform: [{ translateY: -liftPx }] });
  return out;
}
